export const env: { [s: string]: string | null } = {
  npm_package_version: '0.0.59',
  current_version_date: '17.04.2024',
};
